// extracted by mini-css-extract-plugin
export default {"wrapper":"StudentCourseIndicators_wrapper__o94Fx"};